'use strict';
'use es6';

var _PublicApp = require('./PublicApp');

var _PublicApp2 = _interopRequireDefault(_PublicApp);

var _createConfigInterface = require('./createConfigInterface');

var _createConfigInterface2 = _interopRequireDefault(_createConfigInterface);

var _PublicUsageTracker2 = require('pricing-pages-unified-ui/utils/_PublicUsageTracker');

var _PublicUsageTracker3 = _interopRequireDefault(_PublicUsageTracker2);

var _AuthType = require('pricing-pages-unified-ui/constants/AuthType');

var _getProductsNoAuth = require('self-service-api/api/getProductsNoAuth');

var _getPublicPagePath = require('pricing-pages-unified-ui/utils/getPublicPagePath');

var _getPublicPagePath2 = _interopRequireDefault(_getPublicPagePath);

var _identityHelper = require('pricing-pages-unified-ui/utils/identityHelper');

var _CopyMachineApi = require('pricing-pages-unified-ui/api/CopyMachineApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initializePublicCopyExperiments = function initializePublicCopyExperiments() {
  return (0, _CopyMachineApi.initializeCopyMachine)('pricing-pages-public', (0, _identityHelper.getUtk)());
};

var publicConfig = (0, _createConfigInterface2.default)({
  authType: _AuthType.PUBLIC,
  rootUrl: (0, _getPublicPagePath2.default)(),
  tracker: (0, _PublicUsageTracker3.default)(),
  blockingRequests: [initializePublicCopyExperiments],
  defaultHubRoute: '/marketing',
  getMerchandiseCatalog: function getMerchandiseCatalog() {
    return (0, _getProductsNoAuth.getProducts)({
      apiGetter: window.quickFetch.getRequestStateByName('merchandise')
    }).then(function (catalog) {
      return {
        metadata: {
          productCatalog: catalog.products,
          authState: 'NOT_AUTHED', // TODO: kill this concept in self-service-api
          customerCurrencyCode: null,
          availableTrials: [],
          productBasedOffers: null,
          parcels: []
        },
        purchaseMotionsByLocation: null
      };
    });
  }
});
new _PublicApp2.default(publicConfig).start();


//////////////////
// WEBPACK FOOTER
// ./js/publicStart.js
// module id = 874
// module chunks = 4